import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import { noteServices } from "../../../APIServices/SitePilotManagement/noteServices";
import Swal from "sweetalert2";

const UpdateNotes = ({ setAction, title, noteData, setNoteData, getNoteList }) => {
  const [note, setNote] = useState("");
  const [loader, setLoader] = useState(false);

  const updatedNote = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this note?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true)
        let userData = {}
        userData.noteId = noteData?.noteId
        userData.note = note
        let data = await noteServices.updatedNote(userData)
        if (data?.statusCode === 200) {
          getNoteList()
          clearData();
        }
        setLoader(false)
      }
    });
  };

  const clearData = () => {
    setNote("");
    setNoteData("");
    setAction("");
    setLoader(false)
  }

  useEffect(() => {
    if (noteData) {
      setNote(noteData?.note || "");
      setLoader(false)
    }
  }, [noteData]);

  return (
    <Form>
      <Form.Group className="mb-2">
        <Form.Control
          name="notes"
          as={`textarea`}
          rows={4}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Enter Notes"
        />
      </Form.Group>
      <div className="d-flex justify-content-end gap-2 mt-3">
        <Button style={{ fontSize: 12 }} variant="light" onClick={clearData}>
          Cancel
        </Button>
        <Button
          disabled={!note || loader}
          onClick={updatedNote}
          style={{ fontSize: 12 }}>
          {title}
        </Button>
      </div>
    </Form>
  );
};

export default UpdateNotes;
